import { injectIntl, defineMessages } from 'react-intl';
import { Field, reduxForm } from 'redux-form';
import { CHAT_SEARCH_FORM } from 'constants/Chat';
import React, { Component } from 'react';
import { PropTypes as PT } from 'prop-types';
import classes from './ChatSearch.module.scss';

const messages = defineMessages({
  searchChatContacts: {
    id: 'components.chat.searchChatContacts',
    defaultMessage: 'Enter a person’s name or meeting name'
  }
});

class ChatSearchBar extends Component {
  constructor(props) {
    super(props);
    this.focus = this.focusHandler.bind(this);
  }

  componentDidMount() {
    if (this.searchField) {
      this.searchField.getRenderedComponent().focus();
    }
  }

  focusHandler() {
    this.props.handleSetIsFocused(true);
  }

  render() {
    const placeholder = this.props.intl.formatMessage(messages.searchChatContacts);
    const specialProps = { placeholder };

    return (
      <div className={classes.fieldContainer}>
        <Field
          id="chatContactSearch"
          onFocus={this.focus}
          name="chatSearchBar"
          component="input"
          type="text"
          className={classes.chatSearch}
          ref={(input) => {
            this.searchField = input;
          }}
          forwardRef
          {...specialProps}
          data-testid="chatContactSearch"
          maxLength={64}
        />
      </div>
    );
  }
}

ChatSearchBar.propTypes = {
  intl: PT.object,
  handleSetIsFocused: PT.func
};

export default reduxForm({
  form: CHAT_SEARCH_FORM,
  getFormState: (state) => state.app.form
})(injectIntl(ChatSearchBar));
